import { useState } from 'react'

import { UserProfileRole } from '../modules/users/types/UserProfile.ts'
import { customFetch } from '../utils/customFetch.ts'
import DealDto from '../interfaces/DealDto.ts'
import Deal from '../interfaces/Deal.ts'

import { makeUrlDeal, makeUrlDealDetail } from './connectionData.tsx'
import { useAuth } from './useAuth.tsx'

const useDealFetcher = () => {
  const [errorDeal, setErrorDeal] = useState<Error | null>(null)
  const [loading, setLoading] = useState<boolean>(false)
  const { userData, hasRole } = useAuth()
  const fetchDeals = async (orgId: string, status: number) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlDeal(orgId, status)
      const deals = await customFetch<DealDto[]>(apiUrl)

      const mustFilter = !hasRole(UserProfileRole.AllDeals) && hasRole(UserProfileRole.OwnDeals)

      const dealsNew = mustFilter
        ? deals.filter((d) => {
            // Handle both cases: profile as string ID or profile as object
            const dealProfileId = typeof d.profile === 'string' ? d.profile : (d.profile as { _id: string })?._id

            return dealProfileId === userData?.profile?._id
          })
        : deals

      setErrorDeal(null)

      return dealsNew
    } catch (err) {
      // Assert the error as an instance of Error
      const myErr = err instanceof Error ? err : new Error('An unknown error occurred')
      setErrorDeal(myErr)

      return []
    } finally {
      setLoading(false)
    }
  }

  const fetchDealDetail = async (id: string) => {
    setLoading(true)

    try {
      const apiUrl = makeUrlDealDetail(id)
      const deal = await customFetch<Deal>(apiUrl)
      setErrorDeal(null)

      // NO Le quitamos el timezone a las fechas para que no
      // hayan problemas después
      /*
      const convertedActivities = deal.body.activities.map((activity) => ({
        ...activity,
        date: activity.date,
      }));

      deal.body.activities = convertedActivities
      */
      return deal
    } catch (err) {
      // Assert the error as an instance of Error
      const myErr = err instanceof Error ? err : new Error('An unknown error occurred')
      setErrorDeal(myErr)

      return null
    } finally {
      setLoading(false)
    }
  }

  // Exponemos estas variables al exterior
  return { errorDeal, loading, fetchDeals, fetchDealDetail }
}
export default useDealFetcher
